export enum PanelWidth {
  Small = '15rem',
  Medium = '45rem',
  Large = '60rem',
  XLarge = '75rem',
}
